var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',[_vm._v("© 2020 Pranjalya Tiwari")]),_c('div',[_vm._v(" Cover Image : Hubble Ultra Deep Field, courtesy of Hubble Telescope ")]),_c('Social')],1)}
var staticRenderFns = []

export { render, staticRenderFns }